import designItem from './DesignTextarea.vue'
const DesignTextarea = {
  install: function (Vue) {
    Vue.component('DesignTextarea', designItem)
  }
}
export default DesignTextarea
